import React from "react";

const WHATSAPP_NUMBER = "919717185952";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

const WhatsAppFloat = () => {
  const isJapanPage =
    typeof window !== "undefined" && window.location.pathname.startsWith("/jp");

  return (
    <a
      href={WHATSAPP_URL}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label={isJapanPage ? "Koderboxに問い合わせる" : "Chat with Koderbox on WhatsApp"}
      onClick={() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "whatsapp_click",
          page_path: window.location.pathname,
        });
      }}
    >
      <i className="fa fa-whatsapp whatsapp-float__icon" aria-hidden="true" />
      <span className="whatsapp-float__label">
        {isJapanPage ? "お問い合わせ" : "Book Demo"}
      </span>
    </a>
  );
};

export default WhatsAppFloat;
